export class FordocUser{
  id: number;
  name?: string;
  lastName?: string;
  firstName?: string;
  email?: string;
  keycloakId?: string;
  university?: string;
}
